const EventBus = window.EventBus;

export const NewToggleListAbsoluteAdvanced = {
  template: //html 
    `
    <div class="relative search-dropdown"  @click.stop="display(component)" >
    <div v-if="disabled" class="absolute top-0 bottom-0 left-0 right-0 bg-secondary-light opacity-75 search-dropdown-content"></div>
      <div class="w-full flex content-between border border-secondary search-dropdown-title-section">
        <div @click.stop="display(component)" class="pl-3 p-1 lg:pl-3 lg:p-1 w-full text-left text-secondary overflow-hidden cursor-pointer h-8 search-dropdown-title">
          {{ component == 'salepending' ? displayName.replace(/0/g, 'NO').replace(/1/g, 'YES') : displayName }} 
        </div>
        <div v-show="!show" @click.stop="display(component)" class="cursor-pointer w-10  bg-white text-center px-3 pt-3 lg:px-3 lg:pt-3 list-advanced-off">
          <svg viewBox="0 0 20 30"  class="w-3 h-3 fill-current text-primary-light list-advanced-svg-off" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 11.5L0.25 22.3253V0.674683L19 11.5Z"/>
          </svg>
        </div>
        <div v-show="show" @click.stop="display(component)" class="cursor-pointer w-10 bg-primary-light pt-3 lg:px-3 lg:pt-3 px-3 border border-primary-light text-center list-advanced-on">
          <svg viewBox="0 0 22 30" class="w-3 h-3 fill-current text-white list-advanced-svg-on" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.5 19L0.674683 0.25L22.3253 0.25L11.5 19Z" />
          </svg>
        </div>
      </div>
      <transition name="fade">
      <div @click.stop="" v-if="show" :class="isResponsive ? 'lg:absolute' : ''" class="p-3 w-full z-50 bg-white border border-secondary-light h-auto max-h-200 overflow-y-auto">
        <div v-for="item in items">
          <label class="custom-checkbox text-left uppercase">          
           <span class="item-checkbox"> {{ component=='condition' ? $t(item) : (item == 0 ? 'No' : (item == 1 ? 'Yes' : item) ) }} </span>
          <small>{{getCount(item)}}</small>
            <input
              @change="toggle(component, item)"
              :key="item" 
              type="checkbox"
              :value="item"
              :name="item"
              :checked="original_selected.includes(item.toUpperCase())"> 
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
      </transition>
    </div>
  `,
  data: function () {
    return {
      show: false,
      uniqueInList: null,
      theme_directory: window.theme_directory,
      selected: [],
      original_selected: [],
      loaded: false,
      enable: true,
    };
  },
  props: [
    "component",
    "title",
    "disabledTitle",
    "items",
    "initialSelection",
    "collapse",
    "pivot",
    "disable-responsive",
    "optionsCount",
  ],
  mounted() {
    EventBus.$on("CLOSE_ALL_OPEN_COMPONENTS", () => {
      if (this.show) this.show = false;
    });
    EventBus.$on(
      "CLEAR_ALL_NEW_TOGGLE_LIST_ABSOLUTE_ADVANCED_SELECTION",
      () => {
        this.clearSelection();
      }
    );
    EventBus.$on("NEW_TOGGLE_LIST_ABSOLUTE_ENTRY_POINT", () => { });
  },
  methods: {
    entryPoint(items) {

      items.filter(item => {

        let replace = item.replace(/ /g, "-").replace(/---/g, "-").toLowerCase()
        let replace2 = item.replace(/ /g, "-").replace(/---/g, "-")

        if (this.initialSelection.includes(replace) || this.initialSelection.includes(replace2)) {
          if (this.component == 'condition') {
            this.selected.push(this.$t(item).toUpperCase())
          }
          else {
            this.selected.push(item.toUpperCase())
          }
          this.original_selected.push(item.toUpperCase())
        }

      }
      );

      this.$emit("updatechecked", {
        component: this.component,
        selected: this.original_selected,
      });


    },
    clearSelection() {
      this.selected = [];
      this.$emit("updatechecked", {
        component: this.component,
        selected: this.selected,
      });
    },
    display() {
      if (!this.hasItems() || !this.enable) return;
      this.show = !this.show;
    },
    hasItems() {
      return this.items.length > 0;
    },
    toggle(component, item) {

      if (this.original_selected.includes(item.toUpperCase())) {
        let indexSelected

        if (this.component == 'condition') {
          indexSelected = this.selected.indexOf(this.$t(item).toUpperCase())
        }
        else {
          indexSelected = this.selected.indexOf(item.toUpperCase())
        }

        let indexOriginalSelected = this.original_selected.indexOf(item.toUpperCase())

        this.selected.splice(indexSelected, 1);
        this.original_selected.splice(indexOriginalSelected, 1);

      }
      else {
        if (this.component == 'condition') {
          this.selected.push(this.$t(item).toUpperCase());
        }
        else {
          this.selected.push(item.toUpperCase());
        }

        this.original_selected.push(item.toUpperCase());
      }

      this.$emit("updatechecked", {
        component,
        selected: this.original_selected,
      });

    },
    log(text) {
      console.log(text)
    },
    toCapitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    getCount(item) {
      //let newItem =this.toCapitalize(item)
      if (this.optionsCount && this.optionsCount[item.toUpperCase()])
        return `(${this.optionsCount[item.toUpperCase()]})`;
      else
        return "";
    },
    capitalizeItems(items) {
      var arrTwo = items;
      for (var i = 0; i < arrTwo.length; i++) {
        arrTwo[i] = arrTwo[i].toUpperCase().trim();
      }

      const filteredArray = arrTwo.filter(function (ele, pos) {
        return arrTwo.indexOf(ele) == pos;
      });
      return filteredArray;
    },
  },
  watch: {
    items(items) {

      if (!this.loaded) {
        this.entryPoint(items);
        this.loaded = true;
        // this.uppercaseItems;        
      }

    },
  },
  computed: {
    // uppercaseItems(){      

    //   let arrTwo = this.items;

    //   for (var i = 0; i < arrTwo.length; i++) {
    //     arrTwo[i] = arrTwo[i].toUpperCase().trim();
    //   }

    //   const filteredArray = arrTwo.filter(function (ele, pos) {
    //     return arrTwo.indexOf(ele) == pos;
    //   });

    //   return filteredArray;
    // },
    disabled() {
      return !this.hasItems() || !this.enable;
    },
    displayName() {

      if (this.selected.length == 0)
        if (this.disabled && typeof this.disabledTitle != "undefined")
          return this.disabledTitle;

        else return this.title;

      else if (this.selected.length > 2)
        return `${this.selected.slice(0, 2).join(",")}...`;

      else return this.selected.join();

    },
    isResponsive() {
      return !this.disableResponsive == true;
    },
  },
};
